import { EstimateStatuses } from "@legacy/core/utils/enums"

import { ObjectsView } from "@organisms"

import { ESTIMATES_ROUTES } from "@routes/estimates"

export const EstimateObjectsViewTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_open"
            phase="open"
            title="All Open"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", EstimateStatuses.pending],
                ["status", EstimateStatuses.sent],
                ["status", EstimateStatuses.approved],
                ["ordering", "date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="pending"
            phase="open"
            title="Pending"
            endpointKwargs={[
                ["status", EstimateStatuses.pending],
                ["ordering", "date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="sent"
            phase="open"
            title="Sent"
            endpointKwargs={[
                ["status", EstimateStatuses.sent],
                ["ordering", "date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="approved"
            phase="open"
            title="Approved"
            endpointKwargs={[
                ["status", EstimateStatuses.approved],
                ["ordering", "date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_closed"
            phase="closed"
            title="All Closed"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", EstimateStatuses.won],
                ["status", EstimateStatuses.lost],
                ["status", EstimateStatuses.cancelled],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="won"
            phase="closed"
            title="Won"
            endpointKwargs={[
                ["status", EstimateStatuses.won],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="lost"
            phase="closed"
            title="Lost"
            endpointKwargs={[
                ["status", EstimateStatuses.lost],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="cancelled"
            phase="closed"
            title="Cancelled"
            endpointKwargs={[
                ["status", EstimateStatuses.cancelled],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={ESTIMATES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={ESTIMATES_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)
